<template lang="pug">
box
  page-title(slot="page-title", title="Carnê de IPTU")
  list-manager.scrollable(
    slot="content",
    :errors="errors",
    :pages="pages",
    :page="page",
    :loading="loading",
    :next="nextPage",
    :prev="prevPage",
    :count="list.length"
  )
    .container.grid-lg(v-if="list.length > 0")
      .columns
        .column.col-6.col-sm-12.my-2(
          v-for="cadastro in list",
          :key="cadastro.id"
        )
          row(:cadastro="cadastro")
      router-view
</template>

<script>
import listMixin, { defaultStoreImports } from "@/mixins/list";
import Row from "./Row";

export default {
  vuex: { carnes: defaultStoreImports },
  components: { Row },
  mixins: [listMixin],
};
</script>
